import styled from "styled-components";

const Container = styled.div`
  padding: 16px 32px;
  border-radius: 8px;
  box-shadow: 0 4px 20px 0 rgba(34, 41, 57, 0.15);
  background-color: #ffffff;
  border-left: 8px solid #8144e5;
  overflow: hidden;
`;

const Information = styled.div``;

const Description = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #222939;
  margin-bottom: 16px;
`;

const Body = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  img {
    margin-right: 32px;
    width: 80px;
  }

  @media (max-width: 1166px) {
    margin-bottom: 20px;
  }

  @media (max-width: 500px) {
    flex-direction: column;

    img {
      margin-right: unset;
    }

    > * {
      margin-bottom: 8px;
    }
  }
`;

const Header = styled.div`
  margin-right: 40px;
  @media (max-width: 500px) {
    margin-right: unset;
    text-align: center;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #222939;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #6f7582;
`;

const Progress = styled.div`
  font-size: 40px;
  font-weight: bold;
  line-height: 0.8;
  color: #222939;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-size: 12px;
    font-weight: bold;
    color: #6f7582;
    margin-top: 4px;
  }
`;

const ProgressBarSection = styled.div`
  width: 100%;

  .ProgressBar__container {
    height: 24px;
    border-radius: 2px;
    background-color: #f4f5f8;
  }

  .Filler__container {
    background: unset;
    background-image: linear-gradient(to top, #b2f0e6, #37b2ac);
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1166px) {
    flex-direction: column;

    .div::nth-child(1) {
      margin-bottom: 16px;
    }
  }
`;

const CheckPoints = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 380px;
  margin-top: 20px;

  @media (max-width: 500px) {
    align-items: flex-start;
    width: 100%;
    flex-direction: column;
  }
`;

const Check = styled.div`
  font-size: 14px;
  line-height: 1.14;
  color: #9da5b8;
  margin-bottom: 16px;
  display: flex;

  img {
    margin-right: 4px;
  }
`;

const Footer = styled.div`
  padding: 24px;
  background-color: #f4f5f8;
  margin: 16px -32px -16px -32px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    color: #8144e5;
    margin-left: 6px;
  }
`;

const IconBg = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  padding: 8px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

const Unchecked = styled.span`
  width: 16px;
  height: 16px;
  border: solid 1px #ccd2e1;
  border-radius: 50%;
  margin-right: 4px;
`;

const ProductPushedCount = styled.div`
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.14;
  text-align: right;
  color: #6f7582;

  span {
    font-weight: bold;
  }
`;

const ProgressNotification = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  margin-right: 8px;
  text-transform: lowercase;
  font-size: 14px;

  span {
    font-weight: bold;
  }
`;

const ProgressNotificationContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export {
  Body,
  Title,
  Check,
  Header,
  Footer,
  IconBg,
  Content,
  Progress,
  Subtitle,
  Container,
  Unchecked,
  Information,
  Description,
  CheckPoints,
  ProductPushedCount,
  ProgressBarSection,
  ProgressNotification,
  ProgressNotificationContainer
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/bannerConductor/YourGoalsBannerStyle.js